"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchRequest = void 0;
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
/**
 * Batch async requests, throttled with a delay
 * to avoid hammering the network
 */
const batchRequest = async (records, request, options = { batchSize: 100, delay: 100 }) => {
    let response = [];
    const data = [];
    const errors = [];
    for (let i = 0; i < records.length; i += options.batchSize) {
        const batch = records.slice(i, i + options.batchSize);
        // capture individual errors
        // as per https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/all#Promise.all_fail-fast_behaviour
        const result = await Promise.all(batch.map((record) => request(record).catch((e) => ({ record, error: new Error(e) }))));
        response = response.concat(result);
        await delay(options.delay);
    }
    // separate successful requests from errors
    response.forEach((res) => {
        if (res && res.error instanceof Error) {
            errors.push(res);
        }
        else {
            data.push(res);
        }
    });
    return {
        errors,
        data,
    };
};
exports.batchRequest = batchRequest;
//# sourceMappingURL=batch-request.js.map